import React, { Component } from "react";
import { Button } from "../../common/Button/Button";
import moment from 'moment';
import api from "../../utils/api";

class ESPNotesLogDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title,
      auditLog:[]
    };
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (e) => {
    if(this.NoteslogDropdown&&this.NoteslogDropdown.contains(e.target)){
      return
    }
    this.setState({
      listOpen: false
    });
  }

  toggleList() 
  {
    const { listOpen } = this.state;
    if(!listOpen)
    {
      /*if(this.props.serviceFrom=="LPM")
      {
        api.getESPNotesLogByServiceId(this.props.nResourceInstanceId).then(({ data }) => {
          this.setState({auditLog: data});
        });
      }
      else
      {
         api.getAuditTrailNotesSPM({nResourceInstanceId: this.props.nResourceInstanceId,})
          .then((data) => {
            this.setState({auditLog: data});
          });
      }*/
      let payload={nResourceInstanceId:this.props.nResourceInstanceId};
      api.getESPNotesLogByServiceId(payload).then(({ data }) => {
        this.setState({auditLog: data});
      });
    }

    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  UpdateFlag() 
  {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
    this.props.UpdateNewNotesFlag(this.props.nResourceInstanceId);
  }

  renderAuditTrail = () => {
    const {auditLog = []} = this.state;
    return auditLog.map((audit,i) => {
      return(
        <div className="mt-2" key={i}>
          <div className="flex justify-content-between">
            <small>{audit.refHH||audit.reqUser}</small>
            <small>{moment(audit.dtCreated).format('lll')}</small>
          </div>
          <div className="audit-body mt-2">
            <div><small>Notes</small></div>
            <div style={{whiteSpace: "pre-line"}}>
              {audit.sNotesHH||audit.sNotes}
            </div>
            {audit.sModule?(""):
            (
              <>
                <div><small>Followup Actions</small></div>
                <div style={{whiteSpace: "pre-line"}}>
                  {audit.sFollowupAction}
                </div>
                <div><small>Follow up on</small></div>
                {audit.dtFollowupOn?moment(audit.dtFollowupOn).format('ll'):""}
              </>
            )}            
          </div>
        </div>
      )
    })
  }
  
  render() {
    const { listOpen } = this.state;
    const {auditLog = []} = this.state;
    return (
      <div style={{float:"left"}}>
        <div className="dd-header" >
          <div className="dd-header-title">
            <Button onClick={() => this.toggleList()}>Trail</Button>
          </div>
        </div>
        {listOpen && (
          <div ref={elem => this.NoteslogDropdown = elem}>
            <div className="dd-list esp-audit">
              {auditLog.length>0&&this.props.bNewNotesAdded?
              (
                <a href="javascript:void(0);" onClick={() => this.UpdateFlag()}>	{"Mark all read"}</a>
              ):("")}
              <div>
                {auditLog.length>0?this.renderAuditTrail():<div className=" audit-body">No notes taken</div>}
              </div>
              {auditLog.length>0&&this.props.bNewNotesAdded?
              (
                <a href="javascript:void(0);" onClick={() => this.UpdateFlag()}>	{"Mark all read"}</a>
              ):("")}
             </div>
          </div>
        )}
      </div>
    );
  }
}

export default ESPNotesLogDropdown;
